import React from 'react';
import { Text } from 'recharts';

type CustomAxisProps = {
  x?: string;
  y?: string;
  payload?: { name: string; value: string };
};

function CustomAxisTick(props: CustomAxisProps): React.JSX.Element {
  const { x = '', y = '', payload = { value: '' } } = props;

  return (
    <Text x={x} y={y} width={75} textAnchor="middle" verticalAnchor="start">
      {payload.value}
    </Text>
  );
}

export default CustomAxisTick;
